var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#E4EEFB",
    width: 60,
    height: 60,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.333 12.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C7.836 0 0 7.835 0 17.5S7.835 35 17.5 35C27.167 35 35 27.165 35 17.5S27.167 0 17.5 0z",
    fill: "#3979FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FCBFF",
    cx: 33.489,
    cy: 25.155,
    r: 9.845
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.49 15.31c.47 0 .933.033 1.386.097.083.685.125 1.384.125 2.094 0 6.261-3.29 11.755-8.234 14.847a9.819 9.819 0 0 1-3.123-7.193c0-5.438 4.408-9.845 9.845-9.845z",
    fill: "#0A41F3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.307 17.534v-.3a4.395 4.395 0 0 0 1.806-3.56c0-2.423-1.946-4.387-4.348-4.387s-4.348 1.964-4.348 4.387c0 1.465.712 2.762 1.806 3.56v.258c-2.72 1.065-4.663 3.82-4.663 7.044 0 .65.65 1.177 1.452 1.177h11.4c.802 0 1.452-.527 1.452-1.177.002-3.182-1.89-5.908-4.557-7.002z",
    fill: "#FFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeller);
export default __webpack_public_path__ + "static/media/seller.fea30553e58386fa6eeb5ee7de7f0a7c.svg";
export { ForwardRef as ReactComponent };